import { render, staticRenderFns } from "./QillRichText.vue?vue&type=template&id=0df43110"
import script from "./QillRichText.vue?vue&type=script&lang=js"
export * from "./QillRichText.vue?vue&type=script&lang=js"
import style0 from "./QillRichText.vue?vue&type=style&index=0&id=0df43110&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports